import { render, staticRenderFns } from "./EditTips.vue?vue&type=template&id=7eb7f1d0&scoped=true"
import script from "./EditTips.vue?vue&type=script&lang=js"
export * from "./EditTips.vue?vue&type=script&lang=js"
import style0 from "./EditTips.vue?vue&type=style&index=0&id=7eb7f1d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb7f1d0",
  null
  
)

export default component.exports